module.exports = __webpack_public_path__ + "media/music4.3aadd20f.mp3";